<template>
  <div>
    <StatusBanner>
      <template slot="header">
        {{headerText}}.
      </template>
      <template slot="actions">
        Its history will be permanently deleted after 28 days. You can <button @click="cleanse" class="text-blue-400 underline">un-trash it</button>.
      </template>
    </StatusBanner>
  </div>
</template>

<script>
import _get         from 'lodash/get'
import parse        from 'date-fns/parse'
import isToday      from 'date-fns/is_today'
import isYesterday  from 'date-fns/is_yesterday'

import StatusBanner from '@/components/StatusBanner.vue'

export default {
  components: {
    StatusBanner
  },

  props: {
    cleanse: {
      type: Function,
      default: () => { console.warn('Cardstock - HomeNumberDeletedBanner: unhandled cleanse function')}
    },
    deletedAt: {type: String, default: ''},
    deletingTeacher: {type: Object, default: () => { return {} }},
    trashLink: {type: Object},
    objectName: {
      type: String,
      required: true
    }
  },

  computed: {
    headerText() {
      if (_get(this.deletingTeacher, 'isCurrent') == true) {
        return 'You put this ' + this.objectName + ' in the trash ' + this.formattedDeletedAt
      } else if (_get(this.deletingTeacher, 'last', null) != null ) {
        return _get(this.deletingTeacher, 'last') + ' put this ' + this.objectName + ' in the trash ' + this.formattedDeletedAt
      } else {
        return 'This ' + this.objectName + ' was put in the trash ' + this.formattedDeletedAt
      }
    },

    formattedDeletedAt() {
      if (isToday(this.deletedAt)) {
        return "today"
      } else if (isYesterday(this.deletedAt)) {
        return "yesterday"
      } else {
        return 'on ' + parse(this.deletedAt).toLocaleString('en-US', {month: 'short', day: 'numeric', year: 'numeric'})
      }
    },
  }
}
</script>
